// CodeMirror `linter()` source for the bulk-add input phase: flags the two
// malformed trailing-tag-group cases the shared parser otherwise absorbs
// silently (see diagnoseBulkLine). Advisory only — "Analyser" stays enabled
// regardless (the parser never rejects a line, it just parses it worse).
import { diagnoseBulkLine } from '@/lib/bulk-add/parse';
import type { Diagnostic } from '@codemirror/lint';
import type { EditorView } from '@codemirror/view';

/** Diagnostic source for `linter()`: one whole-line diagnostic per malformed line. */
export function bulkLintSource(view: EditorView): Diagnostic[] {
  const diagnostics: Diagnostic[] = [];
  const { doc } = view.state;
  for (let i = 1; i <= doc.lines; i++) {
    const line = doc.line(i);
    const diagnostic = diagnoseBulkLine(line.text);
    if (!diagnostic) continue;
    diagnostics.push({
      from: line.from,
      to: line.to,
      severity: 'error',
      message: diagnostic.message,
      actions: [
        {
          name: `Corriger en « ${diagnostic.suggestion || '(titre vide)'} »`,
          apply: (applyView, from, to) => {
            applyView.dispatch({ changes: { from, to, insert: diagnostic.suggestion } });
          },
        },
      ],
    });
  }
  return diagnostics;
}
